/** "5,347 ft" or null when the value is unknown. */
export function formatFeet(value: number | null | undefined): string | null {
  return typeof value === 'number' ? `${value.toLocaleString()} ft` : null;
}

/** "32 mph" or null when the value is unknown. */
export function formatMph(value: number | null | undefined): string | null {
  return typeof value === 'number' ? `${value.toLocaleString()} mph` : null;
}

/** A count with thousands separators, or null when unknown. */
export function formatCount(value: number | null | undefined): string | null {
  return typeof value === 'number' ? value.toLocaleString() : null;
}

/**
 * "10/03/2026" for a YYYY-MM-DD date, or null when unknown. Formatted from
 * its parts so the date is never shifted by a time zone.
 */
export function formatOriginDate(
  value: string | null | undefined,
): string | null {
  const match = value ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(value) : null;
  return match ? `${match[2]}/${match[3]}/${match[1]}` : null;
}
